import React from 'react';

const UserTypeSelect = ({ value, saving, onChange, contact }) => (
  <label
    className="mt-2 flex flex-wrap items-center gap-2 text-xs"
    style={{ color: '#51120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}
  >
    <span>User type:</span>
    <select
      aria-label={`User type for ${contact}`}
      aria-busy={saving}
      value={value || 'early_access'}
      disabled={saving}
      onChange={(event) => onChange(event.target.value)}
      className="text-xs px-2 py-1 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-60"
      style={{
        backgroundColor: '#EEE7D8',
        border: '1px solid #D6D0C2',
        color: '#51120A',
        fontFamily: "'Bricolage Grotesque', sans-serif",
      }}
    >
      <option value="early_access">Early Access</option>
      <option value="tester">Tester</option>
    </select>
    {saving && <span role="status">Saving…</span>}
  </label>
);

export default UserTypeSelect;
